(function () {
  var PROPERTY_KEY = 'Student';
  var NOTE_LIMIT = 1000;
  var NOTE_HEADER = 'School Packs:';

  var state = {
    syncing: false,
    queued: false,
    lastEntries: [],
    lastNote: '',
    pendingNote: null,
    customerNote: ''
  };

  function clean(value) {
    return String(value == null ? '' : value).replace(/\s+/g, ' ').trim();
  }

  function normalizeNoteString(value) {
    return String(value == null ? '' : value).replace(/\r\n/g, '\n');
  }

  function normalizeMultiline(value) {
    return normalizeNoteString(value).trim();
  }

  function truncate(value, max) {
    var str = String(value);
    if (str.length <= max) {
      return str;
    }
    if (max <= 3) {
      return str.slice(0, max);
    }
    return str.slice(0, max - 3) + '...';
  }

  function formatEntry(name, title, quantity) {
    var safeName = truncate(clean(name), 80);
    var safeTitle = truncate(clean(title), 160);
    var entry = safeName + ' - ' + safeTitle;
    if (quantity > 1) {
      entry += ' x' + quantity;
    }
    return truncate(entry, 220);
  }

  function titleForItem(item) {
    var baseTitle = item.product_title || item.title || '';
    var variantTitle = clean(item.variant_title || '');
    if (variantTitle && variantTitle.toLowerCase() !== 'default title' && baseTitle.indexOf(variantTitle) === -1) {
      baseTitle = baseTitle + ' - ' + variantTitle;
    }
    return baseTitle;
  }

  function buildEntriesFromCart(cart) {
    var entries = [];
    if (!cart || !Array.isArray(cart.items)) {
      return entries;
    }
    for (var i = 0; i < cart.items.length; i += 1) {
      var item = cart.items[i];
      var props = item.properties || {};
      if (!Object.prototype.hasOwnProperty.call(props, PROPERTY_KEY)) {
        continue;
      }
      var student = clean(props[PROPERTY_KEY]);
      if (!student) {
        continue;
      }
      entries.push(formatEntry(student, titleForItem(item), item.quantity || 1));
    }
    return entries;
  }

  function buildEntriesSection(entries) {
    var sanitized = [];
    if (!entries || !entries.length) {
      return { entries: sanitized, section: '' };
    }
    var lines = [NOTE_HEADER];
    var used = NOTE_HEADER.length;

    for (var i = 0; i < entries.length; i += 1) {
      var entry = entries[i];
      var line = '- ' + entry;
      var addition = line.length + 1; // newline + line
      if (used + addition > NOTE_LIMIT) {
        var available = NOTE_LIMIT - used - 1;
        if (available <= 0) {
          break;
        }
        var trimmedEntry = truncate(entry, Math.max(available - 2, 0));
        var trimmedLine = '- ' + trimmedEntry;
        if (trimmedLine.length > available) {
          trimmedLine = trimmedLine.slice(0, available);
        }
        lines.push(trimmedLine);
        sanitized.push(trimmedLine.slice(2));
        used = NOTE_LIMIT;
        break;
      }
      lines.push(line);
      sanitized.push(entry);
      used += addition;
    }

    var section = lines.join('\n');
    return { entries: sanitized, section: section };
  }

  function buildEntriesBlock(entries) {
    if (!entries || !entries.length) {
      return '';
    }
    var lines = [NOTE_HEADER];
    for (var i = 0; i < entries.length; i += 1) {
      lines.push('- ' + entries[i]);
    }
    return lines.join('\n');
  }

  function buildNoteFromEntries(entries, customerNote) {
    var sectionData = buildEntriesSection(entries);
    var cleanedCustomer = normalizeMultiline(customerNote);
    var note = sectionData.section;

    if (cleanedCustomer) {
      var spacer = sectionData.section ? '\n\n' : '';
      var available = NOTE_LIMIT - sectionData.section.length - spacer.length;
      if (available <= 0) {
        cleanedCustomer = '';
      } else if (cleanedCustomer.length > available) {
        cleanedCustomer = truncate(cleanedCustomer, available);
      }
      if (cleanedCustomer) {
        note = sectionData.section ? sectionData.section + spacer + cleanedCustomer : cleanedCustomer;
      } else {
        note = sectionData.section;
      }
    } else if (!sectionData.section) {
      note = '';
    }

    return {
      entries: sectionData.entries,
      note: note,
      customerNote: cleanedCustomer
    };
  }

  function refreshNoteFields(note) {
    var fields = document.querySelectorAll('textarea[name="note"]');
    for (var i = 0; i < fields.length; i += 1) {
      if (fields[i].value !== note) {
        fields[i].value = note;
      }
    }
  }

  function extractCustomerNote(noteValue, knownEntries) {
    var normalized = normalizeNoteString(noteValue);
    if (!normalized) {
      return '';
    }
    var expected = knownEntries && knownEntries.length ? buildEntriesBlock(knownEntries) : '';
    if (expected && normalized.indexOf(expected) === 0) {
      var remainder = normalized.slice(expected.length);
      if (remainder.indexOf('\n\n') === 0) {
        remainder = remainder.slice(2);
      } else if (remainder.indexOf('\n') === 0) {
        remainder = remainder.slice(1);
      }
      return normalizeMultiline(remainder);
    }
    if (normalized.indexOf(NOTE_HEADER) === 0) {
      var splitIndex = normalized.indexOf('\n\n');
      if (splitIndex === -1) {
        return '';
      }
      return normalizeMultiline(normalized.slice(splitIndex + 2));
    }
    return normalizeMultiline(normalized);
  }

  function captureCustomerNoteFromElement(element) {
    if (!element) {
      return;
    }
    state.customerNote = extractCustomerNote(element.value, state.lastEntries);
  }

  function captureLatestNoteValue() {
    var active = document.activeElement;
    if (isNoteField(active)) {
      captureCustomerNoteFromElement(active);
      return;
    }
    var fields = document.querySelectorAll('textarea[name="note"]');
    if (fields.length) {
      captureCustomerNoteFromElement(fields[0]);
    } else {
      state.customerNote = '';
    }
  }

  function cartUpdateUrl() {
    if (window.routes && window.routes.cart_update_url) {
      return window.routes.cart_update_url;
    }
    return '/cart/update.js';
  }

  function postNote(note, preferPersistence) {
    var body = JSON.stringify({ note: note || '' });
    var url = cartUpdateUrl();
    if (preferPersistence && navigator.sendBeacon) {
      try {
        var blob = new Blob([body], { type: 'application/json' });
        navigator.sendBeacon(url, blob);
        return Promise.resolve();
      } catch (error) {
        // Fall back to fetch
      }
    }
    return fetch(url, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: body,
      keepalive: !!preferPersistence
    });
  }

  function refreshStateFromCart(cart) {
    state.lastNote = normalizeNoteString(cart && cart.note ? cart.note : '');
    state.pendingNote = null;
  }

  function applyNoteUpdate(entries, preferPersistence) {
    var payload = buildNoteFromEntries(entries.slice(), state.customerNote);
    state.lastEntries = payload.entries.slice();
    state.customerNote = payload.customerNote;
    refreshNoteFields(payload.note);

    if (!payload.note && !state.lastNote && !state.pendingNote) {
      return;
    }
    if (payload.note === state.lastNote && !state.pendingNote) {
      return;
    }
    if (payload.note === state.pendingNote) {
      return;
    }

    var previousNote = state.lastNote;
    state.pendingNote = payload.note;

    postNote(payload.note, preferPersistence)
      .then(function () {
        state.lastNote = payload.note;
        state.pendingNote = null;
      })
      .catch(function () {
        state.pendingNote = null;
        state.lastNote = previousNote;
      });
  }

  function requestCart() {
    return fetch('/cart.js', { credentials: 'same-origin' }).then(function (response) {
      if (!response.ok) {
        throw new Error('Cart fetch failed');
      }
      return response.json();
    });
  }

  function sync() {
    if (state.syncing) {
      state.queued = true;
      return;
    }
    state.syncing = true;

    requestCart()
      .then(function (cart) {
        refreshStateFromCart(cart);
        var entries = buildEntriesFromCart(cart);
        state.lastEntries = buildEntriesSection(entries).entries;
        state.customerNote = extractCustomerNote(state.lastNote, state.lastEntries);

        var payload = buildNoteFromEntries(entries, state.customerNote);
        state.lastEntries = payload.entries.slice();
        state.customerNote = payload.customerNote;
        refreshNoteFields(payload.note);

        if (payload.note === state.lastNote) {
          return;
        }

        var previousNote = state.lastNote;
        state.pendingNote = payload.note;
        return postNote(payload.note).then(function () {
          state.lastNote = payload.note;
          state.pendingNote = null;
        }).catch(function () {
          state.pendingNote = null;
          state.lastNote = previousNote;
        });
      })
      .catch(function () { /* noop */ })
      .finally(function () {
        state.syncing = false;
        if (state.queued) {
          state.queued = false;
          sync();
        }
      });
  }

  function ensureIncluding(data, preferPersistence) {
    if (!data) {
      return;
    }
    var student = clean(data.student);
    var title = clean(data.title);
    if (!student || !title) {
      return;
    }
    var quantity = Number(data.quantity);
    var entry = formatEntry(student, title, quantity > 1 ? quantity : 1);

    if (state.lastEntries.length) {
      var entries = state.lastEntries.slice();
      if (entries.indexOf(entry) === -1) {
        entries.push(entry);
      }
      applyNoteUpdate(entries, preferPersistence);
      return;
    }

    requestCart()
      .then(function (cart) {
        refreshStateFromCart(cart);
        var entries = buildEntriesFromCart(cart);
        if (entries.indexOf(entry) === -1) {
          entries.push(entry);
        }
        state.customerNote = extractCustomerNote(cart && cart.note ? cart.note : '', buildEntriesSection(entries).entries);
        applyNoteUpdate(entries, preferPersistence);
      })
      .catch(function () { /* noop */ });
  }

  function isStudentInput(node) {
    return !!node && node.matches && node.matches('input[name="properties[' + PROPERTY_KEY + ']"]');
  }

  function extractFormEntry(input, form) {
    if (!input) {
      return null;
    }
    var student = clean(input.value);
    if (!student) {
      return null;
    }
    var title = input.getAttribute('data-sp-product-title') || '';
    if (!title && form) {
      title = form.getAttribute('data-sp-product-title') || '';
      if (!title) {
        var container = form.closest('[data-sp-product-title]');
        if (container) {
          title = container.getAttribute('data-sp-product-title') || '';
        }
      }
    }
    if (!title) {
      return null;
    }
    var quantity = 1;
    if (form) {
      var quantityInput = form.querySelector('input[name="quantity"]');
      if (quantityInput) {
        var parsed = parseInt(quantityInput.value, 10);
        if (!isNaN(parsed) && parsed > 1) {
          quantity = parsed;
        }
      }
    }
    return {
      student: student,
      title: title,
      quantity: quantity
    };
  }

  function handleStudentBlur(event) {
    var input = event.target;
    if (!isStudentInput(input)) {
      return;
    }
    var form = input.closest('form');
    ensureIncluding(extractFormEntry(input, form));
  }

  function handleFormSubmit(event) {
    var form = event.target;
    if (!(form instanceof HTMLFormElement)) {
      return;
    }
    var input = form.querySelector('input[name="properties[' + PROPERTY_KEY + ']"]');
    if (!input) {
      return;
    }
    ensureIncluding(extractFormEntry(input, form));
  }

  function handleExpressClick(event) {
    var button = event.target.closest('.shopify-payment-button button');
    if (!button) {
      return;
    }
    captureLatestNoteValue();
    var form = button.closest('form');
    if (!form) {
      applyNoteUpdate(state.lastEntries.slice(), true);
      return;
    }
    var input = form.querySelector('input[name="properties[' + PROPERTY_KEY + ']"]');
    if (!input) {
      applyNoteUpdate(state.lastEntries.slice(), true);
      return;
    }
    ensureIncluding(extractFormEntry(input, form), true);
  }

  function isNoteField(node) {
    return !!node && node.nodeName === 'TEXTAREA' && node.getAttribute('name') === 'note';
  }

  function handleNoteBlur(event) {
    if (!isNoteField(event.target)) {
      return;
    }
    captureCustomerNoteFromElement(event.target);
    applyNoteUpdate(state.lastEntries.slice());
  }

  function handleCheckoutClick(event) {
    var checkoutButton = event.target.closest('button[name="checkout"]');
    if (!checkoutButton) {
      return;
    }
    captureLatestNoteValue();
    applyNoteUpdate(state.lastEntries.slice(), true);
  }

  document.addEventListener('blur', handleStudentBlur, true);
  document.addEventListener('submit', handleFormSubmit, true);
  document.addEventListener('click', handleExpressClick, true);
  document.addEventListener('blur', handleNoteBlur, true);
  document.addEventListener('click', handleCheckoutClick, true);

  if (typeof subscribe === 'function' && window.PUB_SUB_EVENTS && window.PUB_SUB_EVENTS.cartUpdate) {
    subscribe(PUB_SUB_EVENTS.cartUpdate, function () {
      sync();
    });
  }

  function scheduleInitialSync() {
    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', sync);
    } else {
      sync();
    }
  }

  scheduleInitialSync();

  window.SchoolPackCartNote = {
    sync: sync,
    ensureIncluding: ensureIncluding,
    extractFormEntry: extractFormEntry
  };
})();
